<template>
    <div class="animated fadeIn">
        <b-card>
            <form @submit.prevent="validate">
                <div class="form-row justify-content-start">
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group selectpicker" data-live-search="true">
                            <label>Evento</label>
                            <v-wait for="loading-event">
                                <template slot="waiting">
                                <input disabled type="text" value="Aguarde..." class="form-control" />
                                </template>
                                <select :class="{'custom-select': true}" v-model="request.eventId">
                                <option
                                    v-for="(s, index) in events"
                                    :key="index"
                                    :value="s.id"
                                >{{s.name}}</option>
                                </select>
                            </v-wait> 
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label>Terminais POS</label>
                            <model-list-select
                                :list="devices.data"
                                option-value="serialNumber"
                                option-text="serialNumber"
                                v-model="request.machineSerial"
                                placeholder="Digite o serial do terminal"
                                @searchchange="searchDevices"
                            ></model-list-select>              
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label>Usuario</label>
                            <model-list-select
                                :list="users.data"
                                option-value="idUsuario"
                                option-text="nameWithId"
                                v-model="request.userId"
                                placeholder="Digite o nome do vendedor"
                                @searchchange="searchUsers"
                            ></model-list-select>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label>Operador</label>
                            <multi-list-select
                                :list="cashiers.data"
                                option-value="cid"
                                option-text="nameWithSerial"
                                :selectedItems="request.cashier"
                                placeholder="Digite o nome do operador"
                                @searchchange="searchCashiers"
                                @select="onCashierSelect"
                            ></multi-list-select>
                        </div>
                    </div>    
                </div>
                <div class="row justify-content-start">                   
                    <div class="col-sm-12 col-md-3 col-lg-2 col-xl-2">
                        <div class="form-group">
                            <label>Status</label>
                            <v-wait for="loading-paymentstatus">
                                <template slot="waiting">
                                <input disabled type="text" value="Aguarde..." class="form-control" />
                                </template>
                                <select v-model="request.paymentStatus" class="custom-select">
                                <!--multiple="multiple"-->
                                <option
                                    v-for="(s, index) in paymentStatuses"
                                    :key="index"
                                    :value="s.id"
                                    >{{s.name}}</option>
                                </select>
                            </v-wait>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Início</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Início"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.startDate"
                            ></datepicker>
                        </div>
                    </div>                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Término</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Termino"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.endDate"
                            ></datepicker>
                        </div>
                    </div>                    
                </div>
                <input type="submit" class="btn btn-primary" value="Buscar" />
            </form>
        </b-card>
       <b-card>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Pagamentos no Período
                        </small>
                        <h4 class="h4">{{totalSales}}</h4>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="callout callout-warning">
                        <small class="text-muted">
                        Total
                        <br />Descontos no Período
                        </small>
                        <h4 class="h4">{{totalDiscount}}</h4>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="callout callout-warning">
                        <small class="text-muted">
                        Total
                        <br />Cancelamentos no Período
                        </small>
                        <h4 class="h4">{{totalCancelled}}</h4>
                    </div>
                </div>                
            </div>
        </b-card>
        <b-card>
            <div class="row justify-content-start">                
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Dinheiro
                        </small>
                        <h4 class="h4">{{totalCash}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Pix
                        </small>
                        <h4 class="h4">{{totalPix}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Crédito
                        </small>
                        <h4 class="h4">{{totalCredit}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Débito
                        </small>
                        <h4 class="h4">{{totalDebit}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Cashless
                        </small>
                        <h4 class="h4">{{totalCashless}}</h4>
                    </div>
                </div>
            </div>
        </b-card>
        <b-card>
            <b-table
                :items="result.data"
                :fields="fields"
                :striped="true"
                :busy="ctgLoading"
                responsive
            >   
                <template #table-busy>
                    <div class="text-center text-danger">
                        <strong>Aguarde...</strong>
                    </div>
                </template>             
                <template #cell(total)="data">{{formatDecimal(data.value)}}</template>
            </b-table>
             <nav>
                <b-pagination
                    :total-rows="result.rowCount"
                    :per-page.sync="result.pageSize"
                    v-model="currentPage"
                    prev-text="Voltar"
                    next-text="Próximo"
                    @change="onPageIndexChanged"
                    first-text="Primeiro"
                    last-text="Último"
                />
            </nav>
        </b-card>
    </div>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { MultiListSelect,  ModelListSelect} from "vue-search-select";
import Datepicker from "vuejs-datepicker";
import { getDateDayBefore } from "../../../shared/utils";
import reportPage from '../reportPage';
import barOrderService from '../../../services/BarOrders/BarOrderService';
import cashiersService from '../../../services/Cashiers/CashiersService';
import devicesService from '../../../services/Devices/DevicesService';
import salesUsersService from '../../../services/SalesUsers/SalesUsersService';
import eventService from '../../../services/Events/EventService';
export default {
    name: "report-bar-categories",
    inheritAttrs: false,
    mixins: [reportPage],
    components: {
        ModelListSelect,
        MultiListSelect,
        Datepicker
    },
    data() {
        return {
            request: {
                startDate: new Date(),
                endDate: new Date(),
                eventId: null,
                cashier: [],
                machineSerial: '',                
                paymentTypeId: null,
                paymentStatus: null,
                userId: null
            },
            ctgLoading: false,
            cashiers: {
                data: [],
                query: '',
            },
            devices: {
                data: [],
                query: '',
            },            
            events: [],
            paymentTypes: [{ id: null, name: 'Todos'}, { id: 'CASH', name: 'Dinheiro'}, { id: 'PIX', name: 'Pix'}, { id: 'CREDIT_CARD', name: 'Crédito'}, { id: 'DEBIT_CARD', name: 'Débito'}],
            paymentStatuses: [{ id: null, name: 'Todos'}, { id: 'PAID', name: 'Pago'}, { id: 'CANCELLED', name: 'Cancelado'}],
            fields:[                
                { key: "eventName", label: "Evento", sortable: false },
                { key: "family", label: "Categoria", sortable: false },
                { key: "itemCount", label: "Saida", sortable: false },                
                { key: "total", label: "vendas", sortable: false },
                { key: "actions", label: "" }               
            ],
            summaryResult: {
                totalSales: 0,
                totalCash: 0,
                totalPix: 0,
                totalDebit: 0,
                totalCredit: 0,
                totalCashless: 0
            },
            tpvResult: {
                total: 0,
                discount: 0,
                cancelled: 0,
            },
            users: {
                data: [],
                query: '',
            },
            events: []
        }
    },
    computed: {
        totalSales() {
            return this.formatDecimal(this.tpvResult.total);
        },
        totalDiscount() {
            return this.formatDecimal(this.tpvResult.discount);
        },
        totalCancelled() {
            return this.formatDecimal(this.tpvResult.cancelled);
        },
        subTotalSales() {
            return this.formatDecimal(this.tpvResult.subTotal);
        },
        totalCash() {
            return this.formatDecimal(this.summaryResult.totalCash);
        },
        totalPix() {
            return this.formatDecimal(this.summaryResult.totalPix);
        },
        totalCredit() {
            return this.formatDecimal(this.summaryResult.totalCredit);
        },
        totalDebit() {
            return this.formatDecimal(this.summaryResult.totalDebit);
        },
        totalCashless() {
            return this.formatDecimal(this.summaryResult.totalCashless);
        }
    },
    filters: {
        stringify(value) {
            return JSON.stringify(value, null, 2);
        }
    },
    async created() {    
        await this.fetchEventsData();    
        this.fetchData(1);
        this.fetchSummaryData();
        this.fetchTpvData();
    },
    mounted() {
        
    },
    methods: {
        async fetchEventsData() {
            this.$wait.start("loading-events");      
            let response = await eventService.getAll();
            this.events = response.status == 204 ? [] : response.data;
            // if(this.events.length > 0) {
            //     this.request.eventId = this.events[0].id;
            // }
            // else {
            //     this.events.unshift({ id: null, name: "Todos" });
            // }
            this.events.unshift({ id: null, name: "Todos" });
            this.$wait.end("loading-events");  
        },
        validate() {
            this.fetchSummaryData();
            this.fetchTpvData();
            this.fetchData(1);
        },
        searchCashiers(q){
            if (q == null || q.length < 2) return;
            const self = this;            
            cashiersService.getAll(q, this.request.eventId, this.request.startDate, this.request.endDate).then(
                (response) => {
                    self.cashiers.data = response.status == 204 ? [] : response.data;                    
                },
                () => {
                    self.cashiers.data = [];
                }
            );
        },
        searchUsers(q){
            if (q == null || q.length < 2) return;
            const self = this;            
            salesUsersService.getAll(q, this.request.eventId).then(
                (response) => {
                    self.users.data = response.status == 204 ? [] : response.data;                    
                },
                () => {
                    self.users.data = [];
                }
            );
        },
        onCashierSelect (items, lastSelectItem) {
            this.request.cashier = items            
        },
        searchDevices(q) {
            if (q == null || q.length < 2) return;
            const self = this;            
            devicesService.getAll(q, this.request.eventId).then(
                (response) => {
                    self.devices.data = response.status == 204 ? [] : response.data;                    
                },
                () => {
                    self.devices.data = [];
                }
            );
        },
        resetSummaryResult() {
            this.summaryResult.totalSales = 0;
            this.summaryResult.totalCash = 0;
            this.summaryResult.totalPix = 0;
            this.summaryResult.totalCredit = 0;
            this.summaryResult.totalDebit = 0;
            this.summaryResult.totalCashless = 0;
        },
         resetTpvResult() {
            this.tpvResult.subTotal = 0;
            this.tpvResult.discount = 0;
            this.tpvResult.cancelled = 0;
            this.tpvResult.total = 0;
            
        },
        fetchData(page) {
            const self = this;
            this.showLoading();
            this.ctgLoading = true;
            barOrderService.searchOrderItemsCategoriesSummary(this.request, page)
            .then(
                (response) => {
                    self.$data.result =
                        response.status == 204 ? self.getEmptyResult() : response.data;                                                 
                    self.hideLoading();
                    self.ctgLoading = false;
                },
                () => {
                    self.result = self.getEmptyResult();
                    self.hideLoading();
                    self.ctgLoading = false;
                }
            );
        },
        fetchTpvData() {
            const self = this;
            this.showLoading();
            barOrderService.getTpv(this.request)
            .then(
                (response) => {
                    self.resetTpvResult();
                    if(response.status == 200) {
                        self.tpvResult = response.data;
                    }
                    self.hideLoading();
                },
                () => {
                    self.resetTpvResult();
                    self.hideLoading();
                }
            );
        },
        fetchSummaryData() {
            const self = this;
            this.showLoading();
            
            barOrderService.searchSummary(this.request)
            .then(
                (response) => {
                    self.resetSummaryResult();
                    if(response.status == 200) {                                                
                        let row = {};
                        for(let i = 0; i <= response.data.length - 1; i++) {
                            row = response.data[i];
                            switch(row.paymentTypeId) {
                                case 'CASH':
                                    self.summaryResult.totalCash = self.formatDecimal(row.amount);
                                    break;
                                case 'CREDIT_CARD':
                                    self.summaryResult.totalCredit = self.formatDecimal(row.amount);
                                    break;
                                case 'PIX':
                                    self.summaryResult.totalPix = self.formatDecimal(row.amount);
                                    break;
                                case 'DEBIT_CARD':
                                    self.summaryResult.totalDebit = self.formatDecimal(row.amount);
                                    break;
                                case 'TOTAL_SALES':
                                    self.summaryResult.totalSales = self.formatDecimal(row.amount);
                                    break;
                            }
                            self.summaryResult.totalCashless = self.formatDecimal(0);
                        }
                    }
                    self.hideLoading();
                },
                () => {
                    self.resetSummaryResult();
                    self.hideLoading();
                }
            );
        },
        getPaymentStatusName(data) {
            switch(data) {
                case 'PAID': return 'Pago'
                case 'CANCELLED': return 'Cancelado'
                default: return ''
            }
        }
    }
}
</script>